<template>
    <v-row>
        <v-col cols="12" sm="9">
            <v-row>
                <v-col cols="6" sm="5">
                    {{$t('backoffice.modules-management.parts-information.brands-list')}}
                    <v-text-field
                        v-model="searchNonSelected"
                        class="search mt-3"
                        :label="$t('backoffice.components.search.title')"
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                    <v-simple-table
                        fixed-header
                        height="400px">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">
                                    {{$t('backoffice.general.name')}}
                                </th>
                                <th class="text-center">
                                    {{$t('backoffice.modules-management.parts-information.select')}}
                                </th>
                            </tr>
                            </thead>
                            <draggable
                                class="drag-table"
                                :class="nonSelected.length == 0 ? 'min-dragDrop' : ''"
                                ref="nonSelected"
                                :list="nonSelected"
                                group="people"
                                @change="onNonSelectedChange"
                                tag="tbody">
                                <tr v-for="(element, index) in nonSelected" :key="element.brandId">
                                    <td><span>{{ element.brandDescription }}</span></td>
                                    <td class="flex-row align-center" style="justify-items: center;">
                                        <v-checkbox
                                            :input-value="element.isSelected"
                                            @click.stop="favourite(element.brandId)"
                                            :disabled="!element.isSelected && selectedBrandsCount >= 25"
                                        />
                                    </td>
                                </tr>
                            </draggable>
                        </template>
                    </v-simple-table>

                </v-col>
                <v-col cols="12" sm="2" class="align-center justify-center" :class="$vuetify.breakpoint.xsOnly ? 'd-none' : 'd-flex'">
                    <v-row>
                        <v-col cols="12" class="text-center">
                            <img src="/images/_SVGs/bo/seta-direita.svg" onload="SVGInject(this)" width="20" height="20" />
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <img src="/images/_SVGs/bo/seta-esquerda.svg" onload="SVGInject(this)" width="20" height="20" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6" sm="5">
                    {{$t('backoffice.modules-management.parts-information.my-brands-selection')}} [{{ selectedBrandsCount }} {{$t('backoffice.modules-management.parts-information.between')}}]

                    <v-text-field
                        v-model="searchSelected"
                        class="search mt-3"
                        :label="$t('backoffice.components.search.title')"
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                    <v-simple-table
                        fixed-header
                        height="400px">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">
                                    {{$t('backoffice.general.name')}}
                                </th>
                                <th class="text-center">
                                    {{$t('backoffice.modules-management.parts-information.select')}}
                                </th>
                            </tr>
                            </thead>
                            <draggable
                                class="drag-table"
                                :class="selected.length == 0 ? 'min-dragDrop' : ''"
                                ref="selected"
                                :list="selected"
                                group="people"
                                @change="onSelectedChange"
                                tag="tbody">
                                <tr v-for="(element, index) in selected" :key="element.brandId">
                                    <td><span>{{ element.brandDescription }}</span></td>
                                    <td class="flex-row align-center" style="justify-items: center;">
                                        <v-checkbox
                                            :input-value="element.isSelected"
                                            @click.stop="favourite(element.brandId)"
                                        />
                                    </td>
                                </tr>
                            </draggable>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-col>
        <small>*{{$t('backoffice.modules-management.parts-information.at-least-one-brand')}}</small>
    </v-row>
</template>
<script>
import draggable from 'vuedraggable'
import _ from "lodash";

export default {
    props:{
        brands: Array | Object
    },
    components: {
        draggable
    },
    data() {
        return {
            nonSelected: [],
            selected: [],
            searchNonSelected:'',
            searchSelected:'',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        };
    },
    methods: {
        log: function(evt) {
            this.searchFormNonSelected()
            this.searchFormSelected()
        },
        searchFormNonSelected(){
            let td = this.$refs.nonSelected.$el.querySelectorAll('td');
            this.filterTable(td, this.searchNonSelected);
        },
        searchFormSelected(){
            let td = this.$refs.selected.$el.querySelectorAll('td');
            this.filterTable(td, this.searchSelected);
        },

        filterTable(td, filter){
            let a, i, txtValue;
            let filterUpper = filter.toUpperCase();

            for (i = 0; i < td.length; i++) {
                a = td[i].getElementsByTagName("span")[0];
                if(a){
                    txtValue = a.textContent || a.innerText;
                    if (txtValue.toUpperCase().indexOf(filterUpper) > -1) {
                        td[i].closest('tr').style.display = "";
                    } else {
                        td[i].closest('tr').style.display = "none";
                    }
                }

            }
        },
        organizeDrop(values){
            const v = _.cloneDeep(values)
            this.nonSelected = v.filter(el => el.isSelected == false)
            this.nonSelected = _.orderBy(this.nonSelected, ['brandDescription', 'isSelected'], ['asc', 'desc']);

            this.selected = v.filter(el => el.isSelected == true)
            this.selected = _.orderBy(this.selected, ['brandDescription', 'isSelected'], ['asc', 'desc']);
        },
        favourite(id){
            let brand =
                this.nonSelected.find((b) => b.brandId === id) ||
                this.selected.find((b) => b.brandId === id);
            if (!brand.isSelected && this.selectedBrandsCount >= 25) {
                return;
            }

            for (let key in this.nonSelected) {
                if(this.nonSelected[key].brandId == id){
                    Object.assign(this.nonSelected[key], {
                        isSelected: !this.nonSelected[key].isSelected
                    });
                }
            }

            for (let key in this.selected) {
                if(this.selected[key].brandId == id){
                    Object.assign(this.selected[key], {
                        isSelected: !this.selected[key].isSelected
                    });
                }
            }

            this.organizeDrop([...this.nonSelected, ...this.selected]);
        },
        onNonSelectedChange(evt) {
            if (evt.added && evt.added.element) {
                evt.added.element.isSelected = false;
            }
            this.organizeDrop([...this.nonSelected, ...this.selected]);
        },
        onSelectedChange(evt) {
            if (evt.added && evt.added.element) {
                evt.added.element.isSelected = true;
            }
            this.organizeDrop([...this.nonSelected, ...this.selected]);
        },
    },
    watch:{
        searchNonSelected: {
            handler: function(newValue, oldValue) {
                this.searchFormNonSelected()
            },
            deep: true,
        },
        searchSelected: {
            handler: function(newValue, oldValue) {
                this.searchFormSelected()
            },
            deep: true,
        },
        brands: {
            handler: function(newValue, oldValue) {
                this.organizeDrop(newValue)
            },
            immediate: true,
            deep: true,
        },

        nonSelected: {
            handler: function(newValue, oldValue) {
                this.$emit('newNonSelected', newValue)
            }
        },
        selected: {
            handler: function(newValue, oldValue) {
                this.$emit('newSelected', newValue)
            }
        },
    },
    computed: {
        selectedBrandsCount() {
            return this.selected.length;
        }
    }
};
</script>

<style lang="scss" scoped>

thead{
    tr{
        th{
            background-color: #F2F2F2 !important;
            color:#9E9D9D !important;
            font-weight: 500;
            border: 0;
        }
    }
}
::v-deep table{
    border: 1px solid #f2f2f2 !important;
}
.drag-table{
    display: contents;
    tr{
        &:hover{
            background: #9E9D9D;
        }
        td{
            padding: 16px;
        }
    }
}

.star-inline{
    fill:transparent;
    stroke: #f3c116;
}
.star{
    fill: #f3c116 !important;
}
.min-dragDrop{
    min-height: 200px;
    display: inline-block;
    width: 163%;
}
</style>
